export default function(array) {
  return (array[array.length-1] - array[0]) || 0;
}



// WEBPACK FOOTER //
// ./~/vega-parser/src/parsers/expression/span.js